import Model from "./model";

const SCREEEN_STATUS_CD = {
  INITIALIZE: "0",
  ACTIVE: "1",
  PROCESSING: "2",
  LOADING: "3",
};

class ScreenStatus extends Model {
  /* eslint-disable no-unused-expressions */
  constructor(statusCd = SCREEEN_STATUS_CD.INITIALIZE) {
    super();

    this._statusCd = statusCd;
  }
  /* eslint-enable */

  get statusCd() {
    return this._statusCd;
  }

  set statusCd(value) {
    this._statusCd = value;
  }

  copyInstance() {
    // TDOO: リスト、クラス、ディクショナリは、{ ...ob}でコピーを作成する。
    const newObj = new ScreenStatus();
    newObj.statusCd = this.statusCd;
    return newObj;
  }
}

export {
  ScreenStatus,
  SCREEEN_STATUS_CD,
};
